export default __webpack_public_path__ + "static/media/Shoes.999b3198.png";